'use client';

import { useState } from 'react';
import { HelpCenterLink } from '@trucksmarter/shared';
import NavButton from '../../(authenticated)/_ui/NavItems/NavButton';
import DallasSvgIconHelpOutlined from '../Dallas/Icons/DallasSvgIconHelpOutlined';
import ContactUsDialog from './ContactUsDialog';
import CreateSupportTicketDialog from './CreateSupportTicketDialog';

import NavItemGroup from '../../(authenticated)/_ui/NavItems/NavItemGroup';
import NavLink from '../../(authenticated)/_ui/NavItems/NavLink';

type Props = {
  isBrokerUser?: boolean;
};

export default function SupportNavItemGroup({ isBrokerUser }: Props) {
  const [dialog, setDialog] = useState<React.ReactElement | null>(null);

  return (
    <>
      <NavItemGroup icon={<DallasSvgIconHelpOutlined />} label="Help">
        <NavButton
          label="Submit an issue"
          onClick={() => {
            setDialog(
              <CreateSupportTicketDialog
                onClose={() => setDialog(null)}
                isBrokerUser={isBrokerUser}
              />,
            );
          }}
        />
        {!isBrokerUser && (
          <NavButton
            label="Contact us"
            onClick={() => {
              setDialog(<ContactUsDialog onClose={() => setDialog(null)} />);
            }}
          />
        )}
        <NavLink
          label="Help Center"
          href={HelpCenterLink.HOME}
          target="_blank"
        />
      </NavItemGroup>
      {dialog}
    </>
  );
}
